import { FC } from "react";

import { ConfirmDeactivateModal } from "src/components/Modal";
import { useToast } from "src/components/Toasts/ToastContainer";
import { mapToModalError } from "src/errors";
import { useDisableBlacklistElementMutation } from "src/graphql/anti-fraud/queries/blacklists/mutations/DisableBlacklistElementMutation";
import { useT } from "src/internationalization";
import { BlacklistElementRecord } from "src/pages/Blacklists/blacklist.mapping";
import { useListSchema } from "src/pages/Blacklists/useListSchema";

export type ConfirmDeactivateBlacklistModalProps = {
  blacklistElementRecord: BlacklistElementRecord;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmDeactivateBlacklistModal: FC<ConfirmDeactivateBlacklistModalProps> = ({
  blacklistElementRecord,
  onClose,
  onConfirm,
}) => {
  const { listSchema } = useListSchema();
  const { showSuccessToast } = useToast();
  const t = useT();

  const {
    performMutation: disableBlacklist,
    loading,
    error,
  } = useDisableBlacklistElementMutation({
    onSuccess: () => {
      showSuccessToast(
        t("page.blacklists.table.action.update.status.success.message", {
          status: t("page.blacklists.table.status.inactive").toLowerCase(),
        })
      );

      onConfirm();
    },
  });

  const handleOnConfirm = () => {
    disableBlacklist({ id: blacklistElementRecord.id });
  };

  if (!listSchema) {
    console.error("listSchema is expected to be defined, but is not");
    return null;
  }

  return (
    <ConfirmDeactivateModal
      resourceName={blacklistElementRecord[listSchema.properties[0].name]}
      onConfirm={handleOnConfirm}
      onClose={onClose}
      loading={loading}
      error={mapToModalError(error)}
    />
  );
};
